import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import { ThemeProvider as JssThemeProvider } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { store } from './store';
import theme from './theme';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <BrowserRouter>
        <StyledEngineProvider injectFirst>
          <MuiThemeProvider theme={theme}>
            <JssThemeProvider theme={theme}>
              <CssBaseline />
              <App />
            </JssThemeProvider>
          </MuiThemeProvider>
        </StyledEngineProvider>
      </BrowserRouter>
    </ReduxProvider>
  </React.StrictMode>,
);
